import { FC } from "react";

import { useScheduleEditPageParams } from "~/src/routes/hooks";

import { ScheduleEditFormContainer } from "../../features/settings/ScheduleForm";

import { ScheduleEditPage } from "./presentations";

export const ScheduleEditPageContainer: FC = () => {
  const { siteSlug, scheduleSlug } = useScheduleEditPageParams();

  return (
    <ScheduleEditPage siteSlug={siteSlug} scheduleSlug={scheduleSlug}>
      <ScheduleEditFormContainer
        siteSlug={siteSlug}
        scheduleSlug={scheduleSlug}
      />
    </ScheduleEditPage>
  );
};
